import { load } from 'cheerio';

function parseAdvantageWidget($section, $) {
    const title = $section.find('.advantage_title').first().text().trim();
    const features = [];

    $section.find('li.advantage_feature_row').each((_, li) => {
        const $li = $(li);
        const text = $li.text().trim();
        const $link = $li.find('a');
        if (text) {
            const item = { text };
            if ($link.length) item.href = $link.attr('href') || null;
            features.push(item);
        }
    });

    return { type: 'advantage', title, features };
}

function parseFooterNavWidget($section, $) {
    const $titleEl = $section.find('.footer_col_title').first();
    const title = $titleEl.text().trim();
    const titleHref = $titleEl.attr('href') || null;
    const links = [];

    $section.find('.footer_col_text_row').each((_, li) => {
        const $li = $(li);
        const $a = $li.find('a');
        if ($a.length) {
            links.push({ text: $a.text().trim(), href: $a.attr('href') || null });
        } else {
            const text = $li.text().trim();
            if (text) links.push({ text, id: $li.attr('id') || null });
        }
    });

    const widget = { type: 'footer_nav', title, links };
    if (titleHref) widget.href = titleHref;
    return widget;
}

function parseFilterWidget($section, $) {
    const groups = {};
    let groupIndex = 0;

    $section.find('.filter_list').each((_, list) => {
        const $list = $(list);
        const groupName = $list.find('h4').first().text().trim();
        const options = [];

        $list.find('.filter_term').each((_, term) => {
            const $term = $(term);
            const $input = $term.find('input[type="checkbox"]');
            const $label = $term.find('.filter_checkbox_label');
            const $count = $label.find('.filter_checkbox_count');

            const label = $label.clone().find('.filter_checkbox_count').remove().end().text().trim();
            const count = parseInt($count.text().replace(/[()]/g, '').trim(), 10) || 0;
            const name = $input.attr('name') || null;
            const termId = $input.attr('data-term-id') || null;
            const tax = $input.attr('data-tax') || null;
            const hidden = $term.hasClass('filter_hidden_term');

            if (label) {
                options.push({ label, name, termId, tax, count, hidden });
            }
        });

        const key = $list.hasClass('filter_list_sellers')
            ? 'sellers'
            : `group_${groupIndex++}`;

        groups[key] = { title: groupName, options };
    });

    return { type: 'filters', groups };
}

function parsePopularPostsWidget($section, $) {
    const $script = $section.find('script[type="application/json"]');
    if (!$script.length) return null;

    try {
        const config = JSON.parse($script.html());
        return {
            type: 'popular_posts',
            config: {
                limit: Number(config.limit) || 10,
                range: config.range || 'all',
                orderBy: config.order_by || 'views',
                postType: config.post_type || 'post',
                showViews: config.stats_tag?.views ?? false,
            },
        };
    } catch {
        return null;
    }
}

function parseHeadingWidget($section, $) {
    const text = $section
        .find('.widget-title, .wp-block-heading, h2, h3')
        .first()
        .text()
        .trim();
    if (!text) return null;
    return { type: 'heading', text };
}

function detectAndParse($section, $) {
    if ($section.find('.advantage_block').length) return parseAdvantageWidget($section, $);
    if ($section.find('.footer_column_wrapper, .footer_col_title').length) return parseFooterNavWidget($section, $);
    if ($section.find('.filter-wrapper, .filter_list').length) return parseFilterWidget($section, $);
    if ($section.find('.wpp-shortcode, .popular-posts').length) return parsePopularPostsWidget($section, $);

    const heading = parseHeadingWidget($section, $);
    if (heading) return heading;

    return null;
}

function makeKey(obj, base) {
    if (!obj[base]) return base;
    let i = 2;
    while (obj[`${base}_${i}`]) i++;
    return `${base}_${i}`;
}

export function parseSidebar(sidebar) {
    const $ = load(sidebar.html);
    const widgets = {};
    const advantages = [];

    $('section').each((_, section) => {
        const $section = $(section);
        const parsed = detectAndParse($section, $);
        if (!parsed) return;

        if (parsed.type === 'advantage') {
            advantages.push(parsed);
        } else {
            const key = makeKey(widgets, parsed.type);
            widgets[key] = parsed;
        }
    });

    if (advantages.length > 0) {
        widgets.advantages = advantages;
    }

    return { id: sidebar.id, name: sidebar.name, widgets };
}

export function parseSidebars(sidebars) {
    const byId = {};
    const allIds = [];
    const items = [];

    sidebars.forEach(sidebar => {
        const parsed = parseSidebar(sidebar);
        byId[parsed.id] = parsed;
        allIds.push(parsed.id);
        items.push(parsed);
    });

    return { byId, allIds, items };
}